import { render, staticRenderFns } from "./sendInvoiceDialog.vue?vue&type=template&id=1f18c2c1&"
import script from "./sendInvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./sendInvoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports